import FileUpload from '@/components/file-upload'
import $ from 'jquery'

export default {
    name: 'manage-traitement',
    components: {
        FileUpload
    },
    props: {
        action_info: {
            type: Object,
            default: () => {}
        },
        single_action_info: {
            type: Object,
            default: () => {}
        },
        traitant_id: {
            type: Number,
            default: null
        },
        soin_justif: {
            type: String,
            default: ''
        },
        action_toggler: {
            type: Number,
            default: 0
        },
        preuve: {
            default: null
        },
        medecin_traitant: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            all_checked: false,
            one_is_checked: [],
            required_field_is_empty: false,
            is_error: false,
            error_message: '',
            save_loading: false,

            justif_soin: '',
            can_do_action: true,
            list_medicaments: [],
            is_confirm: false,
            file_upload: null,
            file_type: '',
            assets_url: ''
        }
    },

    watch: {
        action_toggler() {
            this.justif_soin = ''
            this.file_upload = null
            this.is_confirm = false
            this.clearError()

            if (this.preuve != null) {
                this.assets_url = this.assets_path+'/files/consultation_contents'
                this.file_type = this.getFileType(this.preuve)
            }
        },

        action_info() {
            this.clearError()
            this.checkIfCanDoAction()
        },
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        toutSelectionner() {
            this.clearError()
            let is_checked = $('#select-all').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.action_info.medicaments.forEach((el) => {
                    if(this.action_info.process_status == 1 || this.action_info.process_status == 4) {
                        if (el.etat_traitement == 0 || el.etat_traitement == null) {
                            this.one_is_checked.push(el.soin_a_faire_id)
                        }
                    } else if (this.action_info.process_status == 2 || this.action_info.process_status == 3) {
                        if (el.etat_traitement == 1) {
                            this.one_is_checked.push(el.soin_a_faire_id)
                        }
                    }
                    
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            this.clearError()
            document.getElementById("select-all").checked = false;
        },

        checkIfCanDoAction() {
            if (this.action_info.process_status == 1 || this.action_info.process_status == 4) {
                this.list_medicaments = this.action_info.medicaments.filter((el) => (el.etat_traitement == null || el.etat_traitement == 0))
            } else if (this.action_info.process_status == 2 || this.action_info.process_status == 3) {
                this.list_medicaments = this.action_info.medicaments.filter((el) => (el.etat_traitement == 1))
            }
            if (this.list_medicaments.length > 0) {
                this.can_do_action = true
            } else {
                this.can_do_action = false
            }
        },

        setVmodel(response) {
            this.file_upload = response.u_file
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.required_field_is_empty = true
                return
            }

            if (this.action_info.process_status > 2 && this.justif_soin == '') {
                this.required_field_is_empty = true
                return
            }

            const data = {
                evolution_id: this.action_info.evolution_id,
                consultation_id: this.action_info.consultation_id,
                protocole_id: this.action_info.protocole_id,
                medicaments: this.one_is_checked,
                process_status: this.action_info.process_status,
                justif_soin: this.justif_soin,
                traitant_id: this.traitant_id,
                medecin_traitant: {
                    nom_medecin: this.medecin_traitant.user,
                    titre: this.medecin_traitant.titre
                }
            }

            let form_data = new FormData();
            for (let key in data) {
                if (typeof(data[key]) != 'object') {
                    form_data.append(key, data[key])
                } else {
                    form_data.append(key, JSON.stringify(data[key]));
                }
            }
            form_data.append('fichier', this.file_upload);

            this.save_loading = true
            this.$store.dispatch('saveProcessStatus', form_data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitTraitement')

                    document.getElementById("select-all").checked = false;
                    this.one_is_checked = []
                    this.justif_soin = ''
                    this.file_upload = null

                    this.$refs.mng_soins.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        clearError() {
            this.required_field_is_empty = false
            this.is_error = false
            this.error_message = "Une erreur s'est produite !"
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Supprimer une CAT/Consigne
		 */
        submitAction(selector) {
            if (this.single_action_info.process_status > 2 && this.justif_soin == '') {
                this.required_field_is_empty = true
                return
            }

            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            const data = {
                evolution_id: this.single_action_info.evolution_id,
                consultation_id: this.single_action_info.consultation_id,
                protocole_id: this.single_action_info.protocole_id,
                traitant_id: this.traitant_id,
                process_status: this.single_action_info.process_status,
                medicaments: [this.single_action_info.medicament.soin_a_faire_id],
                justif_soin: this.justif_soin,
                medecin_traitant: {
                    nom_medecin: this.medecin_traitant.user,
                    titre: this.medecin_traitant.titre
                }
            }

            let form_data = new FormData();
            for (let key in data) {
                if (typeof(data[key]) != 'object') {
                    form_data.append(key, data[key])
                } else {
                    form_data.append(key, JSON.stringify(data[key]));
                }
            }
            form_data.append('fichier', this.file_upload);

            this.save_loading = true
            this.$store.dispatch('saveProcessStatus', form_data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitTraitement')
                    this.justif_soin = ''
                    this.file_upload = null

                    this.$refs.do_action.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
                this.is_confirm = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}